import { Injectable } from '@angular/core';
import { Http, Weaver, Wrapper } from '@skylab-angular-shared/core';
import { IntegrationRepositoryBase } from '@skylab-shared/business';

@Injectable({ providedIn: 'root' })
@Wrapper(IntegrationRepositoryBase)
export class IntegrationRepository {
    public constructor(
        http: Http,
        weaver: Weaver
    ) { }
}
